import React from 'react'
import { Provider as StoreProvider } from 'react-redux';
import { configureStore } from './store';
import { persistStore } from 'redux-persist';
import { SnackbarProvider } from 'notistack';
import { PersistGate } from 'redux-persist/integration/react';
import './App.css';
import Main from './Main';
import { NotificationToaster } from 'CommonComponent';
import "react-datepicker/dist/react-datepicker.css";



const store = configureStore();
const persistor = persistStore(store);

function App() {
  return (
    <div className="App">

      <StoreProvider store={store}>
      <PersistGate persistor={persistor} >
        <SnackbarProvider anchorOrigin={{ horizontal: 'right', vertical: 'top' }}>
          <NotificationToaster/>
          <Main/>
        </SnackbarProvider> 
      </PersistGate>
    </StoreProvider>
    </div>
  );
}

export default App;
